import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { updateMetaThemeColor } from './utils/themeColor';
import { installBrowserGestureWatch } from './utils/browserGesture';
import './styles/main.scss';

// Before the router listens: notice history steps the browser animates itself (edge swipe back).
installBrowserGestureWatch();

// Apply stored theme and language BEFORE React renders to prevent flash of default styles
(function initializeThemeAndLanguage() {
  // Disable browser's automatic scroll restoration — we manage scroll ourselves
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  // Apply stored language direction
  const storedLanguage = localStorage.getItem('gcxp_language');
  if (storedLanguage) {
    const rtlLanguages = ['he', 'ar'];
    const dir = rtlLanguages.includes(storedLanguage) ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', storedLanguage);
  }
  
  // Apply stored theme colors
  const storedTheme = localStorage.getItem('gcxp_theme_colors');
  if (storedTheme) {
    try {
      const themeColors = JSON.parse(storedTheme);
      const root = document.documentElement;
      if (themeColors.background) {
        root.style.setProperty('--theme-background', themeColors.background);
      }
      if (themeColors.color1) {
        root.style.setProperty('--theme-color-1', themeColors.color1);
      }
      if (themeColors.color2) {
        root.style.setProperty('--theme-color-2', themeColors.color2);
      }
      if (themeColors.color3) {
        root.style.setProperty('--theme-color-3', themeColors.color3);
      }
      if (themeColors.textColor) {
        root.style.setProperty('--theme-text-color', themeColors.textColor);
      }
      root.classList.add('hotel-themed');
      // Mobile Safari status-bar / Dynamic Island colour
      updateMetaThemeColor(themeColors.color1 || themeColors.background);
    } catch (e) {
      console.warn('Failed to parse stored theme colors:', e);
    }
  }
})();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
